/*
  Barre d'annonce — défilement en carrousel.

  Le composant du thème se contente de basculer aria-hidden d'une annonce à
  l'autre, au rythme du réglage « vitesse » de la section. Le CSS sait donc
  qui entre, mais pas qui sort : une annonce masquée est aussi bien celle qui
  vient de céder la place que celle qui attend son tour. On marque ici celle
  qui sort, le temps de l'animation, pour qu'elle parte par la gauche pendant
  que la suivante arrive par la droite.

  Aucune copie d'annonce n'est faite : ce sont des <slideshow-slide> portant
  ref="slides[]", et un doublon fausserait le décompte du composant.
*/
(function () {
  // Doit rester supérieur à la durée de transition fixée dans meon-styles.css.
  var DUREE = 600;

  function brancher(piste) {
    if (!piste || piste.dataset.meonCarrousel) return;
    piste.dataset.meonCarrousel = '1';

    var annonces = [].slice.call(piste.children);

    annonces.forEach(function (annonce) {
      annonce.dataset.meonVisible = annonce.getAttribute('aria-hidden') === 'true' ? '0' : '1';
    });

    function auChangement() {
      annonces.forEach(function (annonce) {
        var masquee = annonce.getAttribute('aria-hidden') === 'true';
        var etaitVisible = annonce.dataset.meonVisible === '1';

        if (masquee && etaitVisible) {
          annonce.classList.add('meon-annonce--sortie');

          window.setTimeout(function () {
            // Retour discret à la position d'attente, à droite : sans couper
            // la transition, l'annonce traverserait l'écran en sens inverse.
            annonce.classList.add('meon-annonce--sans-transition');
            annonce.classList.remove('meon-annonce--sortie');
            void annonce.offsetWidth;
            annonce.classList.remove('meon-annonce--sans-transition');
          }, DUREE);
        }

        annonce.dataset.meonVisible = masquee ? '0' : '1';
      });
    }

    new MutationObserver(auChangement).observe(piste, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function init() {
    var pistes = document.querySelectorAll('.announcement-bar__slides');
    for (var i = 0; i < pistes.length; i++) {
      brancher(pistes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'éditeur de thème reconstruit la section à chaque réglage : on rebranche.
  document.addEventListener('shopify:section:load', init);
})();
